export default "__VITE_ASSET__CqnzuUpo__"